import { render, staticRenderFns } from "./riskScreening.vue?vue&type=template&id=78eaf14e&scoped=true"
import script from "./riskScreening.vue?vue&type=script&lang=js"
export * from "./riskScreening.vue?vue&type=script&lang=js"
import style0 from "./riskScreening.vue?vue&type=style&index=0&id=78eaf14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eaf14e",
  null
  
)

export default component.exports